module.exports = __webpack_public_path__ + "img/header-weddingRingsSecretHeart.ebe7dba.jpg";